import React from 'react';
import {
  DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS_PER_MARKET,
  DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS_PER_MARKET,
} from 'common/dataTableConstants';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrText from 'client/components/SrText';
import SrDataTableUI from 'client/components/SrDataTableUI';
import { SR_TABLE_THEME_HISTORICAL } from 'client/components/SrTable';
import { INVENTORY_ITEM_TYPE_TO_LABEL_MAP } from 'common/inventoryConstants';
import SrBox from 'client/components/SrBox';

function getDataTableSettingsFromProps() {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS_PER_MARKET,
    rootViewId: DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS_PER_MARKET,
    viewId: DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS_PER_MARKET,
    initialViewSettings: {
      loadAllData: true,
    },
    itemsPropName: 'items',
  };
  return dataTableSettings;
}

const SrInventoryPerMarketDataTable = ({ maxHeight }) => {
  const headers = [
    {
      content: 'Market',
      dataTableFieldId: 'marketDisplayName',
      width: '25%',
    },
    {
      content: 'Item Type',
      dataTableFieldId: 'inventoryItemTypeId',
      width: '15%',
    },
    {
      content: 'Available',
      dataTableFieldId: 'availableItems',
      width: '15%',
    },
    {
      content: 'Installed',
      dataTableFieldId: 'assignedItems',
      width: '15%',
    },
    {
      content: 'Broken',
      dataTableFieldId: 'brokenItems',
      width: '15%',
    },
    {
      content: 'Lost',
      dataTableFieldId: 'lostItems',
      width: '15%',
    },
  ];

  return (
    <SrBox maxHeight={maxHeight || 'none'} overflowY="scroll">
      <SrDataTableConnected {...getDataTableSettingsFromProps()}>
        {({
          items,
          viewSettings,
          dataTableApiState,
          onInfiniteScrollWrapperRef,
          dataTableIsFullyLoaded,
        }) => {
          // eslint-disable-line max-len
          if (items.length === 0 && dataTableIsFullyLoaded) {
            return (
              <SrText font="greycliff" weight="500" fontSize="16px">
                No inventory items found.
              </SrText>
            );
          }
          return (
            <div ref={onInfiniteScrollWrapperRef}>
              <SrDataTableUI
                sticky
                theme={SR_TABLE_THEME_HISTORICAL}
                dataTableViewSettings={viewSettings}
                headers={headers}
                minWidth="100%"
                rows={items.map((item) => {
                  return {
                    cells: [
                      {
                        content: item.marketDisplayName,
                      },
                      {
                        content: INVENTORY_ITEM_TYPE_TO_LABEL_MAP[item.inventoryItemTypeId],
                      },
                      {
                        content: item.availableItems,
                      },
                      {
                        content: item.assignedItems,
                      },
                      {
                        content: item.brokenItems,
                      },
                      {
                        content: item.lostItems,
                      },
                    ],
                  };
                })}
              />
              {dataTableApiState.inProgress && (
                <div>
                  <div className="loading-gif clearfix" />
                </div>
              )}
            </div>
          );
        }}
      </SrDataTableConnected>
    </SrBox>
  );
};

export default SrInventoryPerMarketDataTable;
